import { Badge, Stack } from '@mui/material';
import { ArrowsClockwiseIcon } from '@phosphor-icons/react/dist/ssr/ArrowsClockwise';
import { vars } from '@tgtg/kit';
import useNumberOfPendingDonations from 'features/remote-collection/hooks/useNumberOfPendingDonations';
import { useLocation } from 'react-router';

import BottomBarButton from './BottomBarIButton';
import BottomBarUserMenu from './BottomBarUserMenu';

const BottomBar = () => {
  const location = useLocation();
  const isStatusUpdateActive = location.pathname === '/';

  const numberOfDonationsToConfirm = useNumberOfPendingDonations();

  return (
    <Stack
      component='nav'
      direction='row'
      sx={{
        justifyContent: 'space-evenly',
        borderTop: `1px solid ${vars.color.border.neutral}`,
        backgroundColor: vars.color.surface.base,
        flexShrink: 0,
        boxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 0 rgba(255, 255, 255, 0.10) inset',
        backdropFilter: 'blur(60px)',
      }}
    >
      <BottomBarButton
        icon={
          <Badge
            badgeContent={numberOfDonationsToConfirm}
            sx={{
              ['& .MuiBadge-badge']: {
                top: '6px',
                right: '2px',
              },
            }}
          >
            <ArrowsClockwiseIcon
              style={{
                color: 'inherit',
                width: vars.size.medium,
                height: vars.size.medium,
              }}
            />
          </Badge>
        }
        label='Update status'
        to='/'
        isActive={isStatusUpdateActive}
      />
      <BottomBarUserMenu />
    </Stack>
  );
};

export default BottomBar;
